import React from 'react';
import Icon from '../Icon';
import css from './style.module.scss';

export const WarningIcon = () => {
  return <Icon name="warning" className={css.warning_icon} />;
};
